import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { CampaignInConflict, Campaign } from '../../campaign';
import { Store, select, ActionsSubject } from '@ngrx/store';

import * as fromCampaign from '../../state';
import * as campaignActions from '../../state/campaign.actions';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-manage-conflicts-dialog',
  templateUrl: './manage-conflicts-dialog.component.html',
  styleUrls: ['./manage-conflicts-dialog.component.scss']
})
export class ManageConflictsDialogComponent implements OnInit, OnDestroy {
  isloadingConflicts$: Observable<boolean>;
  campaignConflictsChecked = false;
  errorCheckingConflicts = false;
  conflictsFixed = false;
  campaignConflicts: CampaignInConflict[] = [];

  private _subscriptions: Subscription[] = [];

  get hasConflicts(): boolean {
    return this.campaignConflicts.length > 0;
  }

  constructor(private _store: Store<fromCampaign.State>,
    private _actionSubject: ActionsSubject,
    public dialogRef: MatDialogRef<ManageConflictsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Campaign) { }

  ngOnInit() {
    this._store.dispatch(new campaignActions.SetIsLoadingCampaignConflicts);
    this._store.dispatch(new campaignActions.GetCampaignConflicts(this.data.id));
    this.isloadingConflicts$ = this._store.pipe(select(fromCampaign.getIsLoadingConflicts));

    this._subscriptions.push(this._store.pipe(select(fromCampaign.getConflicts))
      .subscribe(conflicts => {
        if (conflicts) {
          this.campaignConflicts = conflicts;
        }
      }));
    this._subscriptions.push(this._actionSubject
      .filter(action => action.type === campaignActions.CampaignActionTypes.getCampaignConflictsFail)
      .subscribe(() => {
        this.errorCheckingConflicts = true;
      }));
    this._subscriptions.push(this._actionSubject
      .filter(action => action.type === campaignActions.CampaignActionTypes.getCampaignConflictsSuccess)
      .subscribe(() => {
        this.errorCheckingConflicts = false;
        this.campaignConflictsChecked = true;
      }));
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(subscription => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  setConflictsFixed(): void {
    this.conflictsFixed = true;
  }

  loadConflicts(): void {
    this._store.dispatch(new campaignActions.SetIsLoadingCampaignConflicts);
    this._store.dispatch(new campaignActions.GetCampaignConflicts(this.data.id));
  }

}
